import type {IssueViewerSecondaryViewServerQueryQuery} from '@github-ui/server-persisted-queries/types/IssueViewerSecondaryViewServerQuery'

import {LABELS} from '../constants/labels'
import styles from './MarkdownLastEditedBy.module.css'

type IssueSecondaryNode = NonNullable<NonNullable<IssueViewerSecondaryViewServerQueryQuery['repository']>['issue']>

type LastUserContentEditEditor = NonNullable<NonNullable<IssueSecondaryNode['lastUserContentEdit']>['editor']>

export type MarkdownLastEditedByFragment = {
  readonly viewerCanReadUserContentEdits: IssueSecondaryNode['viewerCanReadUserContentEdits']
  readonly lastUserContentEdit:
    | {
        readonly editor: Partial<Pick<LastUserContentEditEditor, 'login'>> | null | undefined
      }
    | null
    | undefined
}

type MarkdownLastEditedByProps = {
  editInformation?: MarkdownLastEditedByFragment
  authorLogin?: string | null
  variant?: 'default' | 'compact'
  withSeparator?: boolean
}

export function MarkdownLastEditedBy({
  editInformation: data,
  authorLogin,
  variant = 'default',
  withSeparator = false,
}: MarkdownLastEditedByProps) {
  if (!data || !data.viewerCanReadUserContentEdits || !data.lastUserContentEdit) {
    return null
  }

  const {editor} = data.lastUserContentEdit
  if (!editor && variant === 'default') return null

  const login = variant === 'compact' ? editor?.login || 'ghost' : editor?.login
  const isAuthorEdit = variant === 'compact' && !!authorLogin && login?.toLowerCase() === authorLogin.toLowerCase()

  return (
    <span className={styles.lastEditInfoContainer}>
      {withSeparator && (
        <span className={styles.separator} aria-hidden="true">
          &middot;
        </span>
      )}
      {isAuthorEdit ? (
        <span>{LABELS.editHistory.edited}</span>
      ) : (
        <>
          {`${variant === 'compact' ? LABELS.editHistory.editedByShort : LABELS.editHistory.editedBy} `}
          <span className={styles.editorLogin}>{login}</span>
        </>
      )}
    </span>
  )
}
